import { render } from "./OrganizationSettings.vue?vue&type=template&id=9e65b2f0&ts=true"
import script from "./OrganizationSettings.vue?vue&type=script&lang=ts"
export * from "./OrganizationSettings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__